export const FUNNEL_ROUTE_ID = "funnel";

export const PRE_ELIGIBILITY_ROUTE_ID = "pre-eligibility";

export const FELLOW_ROUTE_ID = "fellow";

export const POST_ELIGIBILITY_ROUTE_ID = "post-eligibility";
